import React, { useMemo, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingWheel from "../../components/Shared/LoadingWheel";
import Breadcrumbs from "../../components/Shared/Breadcrumbs";
import useEmailTemplate from "../../data/emailTemplates/useEmailTemplate";

import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { PageHeader } from "../../components/Shared/PageHeader";
import { useEmailContent } from "../../data/emailContent/useEmailContent";
import { useForm } from "react-hook-form";
import { StyledTextInput } from "../../components/Shared/StyledInputs/StyledTextInput";
import useUserContext from "../../contexts/UserContext";
import TinyMCE from "../../components/Shared/TinyMCE";

interface EmailTemplateFormFields {
    subject: string;
    body: string;
}

// ! THIS IS A PAGE THAT WAS STARTED BUT EMAIL TEMPLATES ARE FOR CLIENTS, MOVED TO SETTINGS FOR THE CLIENT

export default function ViewEmailTemplate() {
    const navigate = useNavigate();
    const { emailTemplateId } = useParams<{ emailTemplateId: string }>();
    const agency = useUserContext();
    console.log("user", agency);
    const { emailTemplate } = useEmailTemplate(emailTemplateId);
    const { emailContent } = useEmailContent(agency.id, emailTemplateId);
    const { register, watch, setValue, handleSubmit, reset } = useForm<EmailTemplateFormFields>();
    const { saveHandlers } = useDefaultCRUDHandlers("Email Template");

    const pages = useMemo(() => [
        { to: "..", label: "Email Template", current: false },
        {
            to: emailTemplateId,
            label: emailTemplate.data?.data ? emailTemplate.data.data.name : "Email Template",
            current: true,
        },
    ], [emailTemplate.data, emailTemplateId]);

    const updateContent = (data: EmailTemplateFormFields) => {
        // update.mutate(template.body, saveHandlers);
    };

    useEffect(() => {
        if (
            !emailTemplate.isLoading &&
            !emailContent.isLoading &&
            emailTemplate.data?.data &&
            emailContent.data?.data
        ) {
            reset({
                subject: emailContent.data.data.subject,
                body: emailContent.data.data.body,
            })
        }
    }, [emailTemplate, emailContent, reset])

    if (emailTemplate.isLoading || emailContent.isLoading) {
        return (
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="h-80 max-w-7xl flex items-center justify-center">
                    <LoadingWheel width="w-12" height="h-12" />
                </div>
            </div>
        );
    } else {
        return (
            <div className="px-4 sm:px-6 lg:px-8">
                <Breadcrumbs pages={pages} />
                <div className="my-6">
                    <PageHeader
                        title={emailTemplate.data?.data.name ?? "Email Template"}
                        description="Make changes to this email template here."
                    />
                </div>
                <form onSubmit={handleSubmit(updateContent)}>
                    <StyledTextInput
                        label="Subject"
                        register={register}
                        registerName="subject"
                    />
                    <TinyMCE
                        // @ts-ignore
                        height={300}
                        // @ts-ignore
                        value={getValues(`content`)}
                        // @ts-ignore
                        onChange={(content: any) => setValue(`content`, content)}
                        // @ts-ignore
                        // mergeTags={[...baseMergeTags, ...getAdditionalMergeTags(watch(`trigger`))]}
                    />
                </form>
            </div>
        );
    }
}

